import "./App.css";
import { BrowserRouter } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Pwa from "./components/Pwa";
import Routes from "./Routes";
import "react-toastify/dist/ReactToastify.css";
import { GeneralProvider } from "./context/GeneralContext";
import TagManager from "react-gtm-module";
import MetaPixel from "./helpers/Pixel/metaPixel";

const tagManagerArgs = {
  gtmId: "GTM-NWC3XV3V",
};
TagManager.initialize(tagManagerArgs);

function App() {
  return (
    <BrowserRouter>
      <MetaPixel />
      <GeneralProvider>
        <Header />
        <div className="container">
          <Routes />
        </div>
        <Footer />
      </GeneralProvider>
      <Pwa />
    </BrowserRouter>
  );
}

export default App;
